import {EndpointEnum} from "../../constants/EndpointEnum";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import IStore from "../../models/IStore";
import * as EffectUtility from '../../utilities/EffectUtility';
import ApiKeyListModel from "../models/ApiKeyListModel";
import ApiKeyModel from "../models/ApiKeyModel";

export default class ApiKeyEffect {

    public static async getApiKeyList(state: IStore):Promise<ApiKeyListModel | HttpErrorResponseModel> {
        return await EffectUtility.getToModel<ApiKeyListModel>(state, ApiKeyListModel, EndpointEnum.apiKeyList);
    }

    public static async createApiKey(state: IStore):Promise<ApiKeyModel | HttpErrorResponseModel> {
        return await EffectUtility.postToModel<ApiKeyModel>(state, ApiKeyModel, EndpointEnum.apiKeyCreate);
    }

    public static async deleteApiKey(state: IStore, keyId: string):Promise<String | HttpErrorResponseModel> {
        return await EffectUtility.deleteToModel<String>(state, String, EndpointEnum.apiKeyDelete.replace(':keyId', keyId));
    }
}